import comp from "./AddChildPageV2";
export default comp;
